var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0038 16 0.00175 16 0C24.8365 0 32 7.1635 32 16Z",
    fill: "#D80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.6521V13.0485L10.4348 7.6521H16Z",
    fill: "#0052B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34821 15.9998H13.0489L8.34821 9.73895L7.65259 14.6085L8.34821 15.9998Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9568 16.0001H15.9996C15.9996 15.9857 15.9996 15.9717 15.9996 15.9573C15.9853 15.9716 15.9711 15.9858 15.9568 16.0001Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.34781C16 5.5325 16 3.68781 16 0H15.9973C7.16194 0.0015 0 7.16431 0 16H8.34781V11.2993L13.0485 16H15.9572C15.9715 15.9857 15.9858 15.9715 16.0001 15.9572C16.0001 14.8793 16.0001 13.9174 16.0001 13.0486L11.2992 8.34781H16Z",
    fill: "#F0F0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09503 2.08691C5.59259 3.51185 3.51216 5.59223 2.08728 8.09466V16.6956H6.26122V6.26098V6.26085H16.696C16.696 4.94441 16.696 3.69029 16.696 2.08691H8.09503Z",
    fill: "#D80027"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6365 14.6684L10.3158 8.34784H8.34827V8.34796L16.6363 16.636H16.6365C16.6365 16.6361 16.6365 15.2794 16.6365 14.6684V14.6684Z",
    fill: "#D80027"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0873 8.3479V16C18.0873 19.7275 27.8264 19.7275 27.8264 16V8.3479H18.0873Z",
    fill: "#F3F3F3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0873 15.9999V15.9999C18.0873 19.7274 22.9568 20.8695 22.9568 20.8695C22.9568 20.8695 27.8264 19.7274 27.8264 15.9999V15.9999H18.0873Z",
    fill: "#6DA544"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9567 12.9392L20.6958 13.9131V16.0001L22.9567 17.3914L25.2176 16.0001V13.9131L22.9567 12.9392Z",
    fill: "#A2001D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6958 11.826H25.2176V13.913H20.6958V11.826Z",
    fill: "#338AF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBm);
export default __webpack_public_path__ + "static/media/BM.008a6f93.svg";
export { ForwardRef as ReactComponent };